//Offline follows the backend, not the portal's own arithmetic. The backend raises an
//OUT_OF_COMMS event and that event is what drives the notification the customer receives, so
//taking the same signal keeps the portal and the customer's inbox telling the same story.
//
//getDevicePresence still estimates from the reporting interval, and that estimate is kept for
//one job: spotting when the two disagree. A device that has gone quiet with no event behind it
//usually means the event pipeline has stalled, and without the warning a whole dead fleet would
//read as healthy.
export const getDeviceOfflineState = ({ presence, commsEvent } = {}) => {
	const hasOpenEvent = Boolean(commsEvent);

	return {
		isOffline: hasOpenEvent,
		offlineSince: commsEvent?.offlineSince ?? null,
		isSilentWithoutEvent: !hasOpenEvent && Boolean(presence?.isOffline),
	};
};
